import { Component, ElementRef, ViewChild, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscriber, Subscription, forkJoin, Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, map, take } from 'rxjs/operators';
import { MatDatepicker } from '@angular/material/datepicker';
import { Hr12to24hrPipe } from 'src/app/hr12to24hr.pipe';
import { DatePipe, Location } from '@angular/common';
import { DialogService } from '../../../services/dialog.service';
import { IsoDateFormatPipe } from '@app/isoDateFormat';
import { Select2Data } from 'ng-select2-component';
import { CountryPhoneCodes } from '@app/components/interface/country-phone-codes';
import { AuthServiceService } from '@app/services/auth-service.service';
import { WarehouseService } from '@app/services/warehouse.service';
import { AddressService } from '@app/services/address.service';
import { OrderService } from '@app/services/order.service';
import { HttpClient } from '@angular/common/http';
import { AddAddressListingComponent } from '../add-address-listing/add-address-listing.component';
import * as moment from 'moment';
import { ErrormodalComponent } from '../errormodal/errormodal.component';
import { ToastService } from '@app/services/toast.service';
import { LoaderService } from '@app/services/loader.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

interface OrderFormData {
  pickup: {
    mode: 'auto' | 'manual' | '';
    purchaseOrder: string;
    company: string;
    address: string;
    date: string;
    time: string;
    contact: string;
    email: string;
    countryCode: string;
    phone: string;
    altPhone: string;
    notes: string;
    timeInterval: string;
    signatureRequired: boolean;
    firstDelivery: Number;
  };
  delivery: {
    mode: 'auto' | 'manual' | "";
    orderNumber: string;
    company: string;
    address: string;
    date: string;
    time: string;
    contact: string;
    email: string;
    countryCode: string;
    phone: string;
    altPhone: string;
    notes: string;
    timeInterval: string;
    signatureRequired: boolean;
    firstDelivery: Number;
  };
}

@Component({
  selector: 'app-add-order',
  templateUrl: './add-order.component.html',
  styleUrls: ['./add-order.component.scss'],
  host: {
    '(window:keyup)': 'onKeyup($event)',
  },
  providers: [Hr12to24hrPipe, IsoDateFormatPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddOrderComponent implements OnInit, OnDestroy, AfterViewInit {

  addOrderF!: FormGroup;
  loading = false;
  isSubmitted = false;
  addressData: any;
  tempCompaniesList: any;
  data: Select2Data = [];
  warehouseData: any;
  orderData: any;
  countryCodes: any = CountryPhoneCodes;

  po: any;

  id: Number;
  isAddMode: boolean;
  fromDetail: boolean = false;

  address$!: Observable<object[]>;
  companies$!: Observable<object[]>;
  warehouse$!: Observable<object[]>;
  order$!: Observable<object[]>;

  time = { hour: 13, minute: 30 };
  isCheckedWarehous: any = [{ pickup: false }, { dely: false }];
  isPickupWareHouseEnabled: boolean = false;
  isDelyWareHouseEnabled: boolean = false;
  addressPickup$: any;
  addressDely$: any;
  companiesList: any = [];
  isonClickOfDelyTriggered: boolean = false;
  isonClickOfPickupTriggered: boolean = false;
  isWearhouse: boolean = true;
  warehouseList: any = [];
  currentTime: any;
  loader: boolean = true;
  dely_company_name_placeholder = 'Company Name';
  pickup_company_name_placeholder = 'Company Name';
  typeOfOrder: any;
  dely_company_name: any;
  pickup_company_name: any;
  ispickuptimetaken = false;
  isdelaytimetaken = false;
  uploadloading: boolean = false;

  timeInterval = [
    { value: 't0', label: 'T0' },
    { value: 't15', label: 'T15' },
    { value: 't30', label: 'T30' },
    { value: 't45', label: 'T45' },
    { value: 't60', label: 'T60' }
  ];
  Delpu = [
    { value: 0, label: 'Select' },
    ...Array.from({ length: 20 }, (_, i) => ({
      value: i + 1,
      label: i + 1
    }))
  ];

  // New UI properties
  orderForm: OrderFormData = {
    pickup: {
      mode: 'auto',
      purchaseOrder: '',
      company: '',
      address: '',
      date: '',
      time: '',
      contact: '',
      email: '',
      countryCode: localStorage.getItem('countryCode') || '+1',
      phone: '',
      altPhone: '',
      notes: '',
      timeInterval: 't15',
      signatureRequired: false,
      firstDelivery: 0
    },
    delivery: {
      mode: 'auto',
      orderNumber: '',
      company: '',
      address: '',
      date: '',
      time: '',
      contact: '',
      email: '',
      countryCode: localStorage.getItem('countryCode') || '+1',
      phone: '',
      altPhone: '',
      notes: '',
      timeInterval: 't15',
      signatureRequired: false,
      firstDelivery: 0
    }
  };

  // Dropdown options
  pickupCompanies: string[] = [];
  deliveryCompanies: string[] = [];
  pickupAddresses: string[] = [];
  deliveryAddresses: string[] = [];

  filteredPickupCompanies: string[] = [];
  filteredDeliveryCompanies: string[] = [];
  filteredPickupAddresses: string[] = [];
  filteredDeliveryAddresses: string[] = [];

  showPickupCompanyDropdown = false;
  showDeliveryCompanyDropdown = false;
  showPickupAddressDropdown = false;
  showDeliveryAddressDropdown = false;

  visiblePickupDelpuCount = 4;
  visibleDelyDelpuCount = 4;
  showPickupDelpuDropdown = false;
  showDelyDelpuDropdown = false;

  get visiblePickupDelpu() {
    return this.Delpu.slice(0, this.visiblePickupDelpuCount);
  }

  get visibleDelyDelpu() {
    return this.Delpu.slice(0, this.visibleDelyDelpuCount);
  }

  errors: { [key: string]: string } = {};
  pickupNotesRemaining = 200;
  deliveryNotesRemaining = 200;
  nextWorkingDate: any;
  minDate: Date | null = null;
  countriescodes: any;
  allow_order_merge: any = 'true';
  page: any;
  isManualChecked = false;
  isManualChecked1 = false;
  private companySearch$ = new Subject<{ term: string, type: 'pickup' | 'delivery' }>();
  private addressSearch$ = new Subject<{ term: string, type: 'pickup' | 'delivery' }>();

  isPickupCompanySearching = false;
  isDeliveryCompanySearching = false;
  isPickupAddressSearching = false;
  isDeliveryAddressSearching = false;

  isCompanySearching = false;
  isAddressSearching = false;
  clearFilterLoading = false;
  isCsvUploaded = true;
  csvFile: File | null = null;
  private initialFormState: string = '';
  require_delivery_signature:any;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthServiceService,
    public warehouseService: WarehouseService,
    public addressService: AddressService,
    public orderService: OrderService,
    private timeConverter: Hr12to24hrPipe,
    private isoDateFormat: IsoDateFormatPipe,
    public dialog: MatDialog,
    public http: HttpClient,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private toast: ToastService,
    private globalLoader: LoaderService,
    private shareddta: ShareddtaService,
    public location: Location,
    private breadcrumbService: BreadcrumbService
  ) {
    this.id = this.route.snapshot.params['id'];
    this.isAddMode = !this.id;
    this.fromDetail = this.route.snapshot.queryParams['fromDetail'] === 'true';

    this.addOrderF = formBuilder.group({
      po: [''],
      pickup_company_name: [''],
      pickup_address: ['', [Validators.required]],
      is_pickup_warehouse: [''],
      pickup_date: [''],
      pickup_time: [''],
      pickup_contact_name: ['', [Validators.required]],
      pickup_email: [''],
      pickup_phone: [
        '',
        [Validators.required, Validators.pattern('^((\\+1-?)|0)?[0-9]{10}$')],
      ],
      pickup_alt_phone: [''],
      pickup_note: [''],
      dely_company_name: [''],
      dely_address: ['', [Validators.required]],
      is_dely_warehouse: [''],
      dely_date: [''],
      dely_time: [''],
      dely_contact_name: ['', [Validators.required]],
      dely_email: [''],
      dely_phone: [
        '',
        [Validators.required, Validators.pattern('^((\\+1-?)|0)?[0-9]{10}$')],
      ],
      country_code: [localStorage.getItem('countryCode') || '+1'],
      dely_alt_phone: [''],
      dely_note: [''],
      order_no: [''],
      pickup_time_interval: [''],
      dely_time_interval: [''],
      pickup_signature_required: [false],
      dely_signature_required: [false],
      is_pickup_first_delivery: [0],
      is_dely_first_delivery: [0],
      isManualChecked: [false],
      isManualChecked1: [false]
    });

    const resolvedData = this.route.snapshot.data['dropdownData'];
    if (resolvedData) {
      this.processDropdownData(resolvedData);
    }
    this.addOrderF.patchValue({ po: this.po });

    const savedCountryCode = localStorage.getItem('countryCode');
    if (savedCountryCode) {
      this.orderForm.pickup.countryCode = savedCountryCode;
      this.orderForm.delivery.countryCode = savedCountryCode;
    }
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.addOrderF.controls;
  }

  // convenience getter for easy access to form values
  get frmValues() {
    return this.addOrderF.value;
  }

  ngOnInit(): void {
    this.breadcrumbService.clear();
    this.shareddta.signalPageReady();
    this.authService.orderAction();
    localStorage.setItem('arkivesearch', 'false');
    this.require_delivery_signature = localStorage.getItem('require_delivery_signature') === 'true';
    console.log('require_delivery_signature', this.require_delivery_signature);
    this.setTheValidatorsForPOON();
    var d: any = this.getNextBusinessDay();
    this.nextWorkingDate = this.dateFormat(d);
    this.minDate = new Date();

    this.orderForm.pickup.date = this.nextWorkingDate;
    this.orderForm.delivery.date = this.nextWorkingDate;

    this.addOrderF.patchValue({
      pickup_date: this.nextWorkingDate,
      dely_date: this.nextWorkingDate
    });

    this.currentTime = this.getTime();
    if (!this.isDelyWareHouseEnabled && !this.isPickupWareHouseEnabled) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = true;
    }
    // Subscribe to shared country code
    this.shareddta.countryCode$.subscribe(code => {
      if (code) {
        this.countriescodes = code;
        this.orderForm.pickup.countryCode = code;
        this.orderForm.delivery.countryCode = code;
        this.addOrderF.patchValue({ country_code: code });
      }
    });

    this.orderForm.pickup.mode = "";
    this.orderForm.delivery.mode = "";

    // Parallelize API calls if not in Add Mode
    if (!this.isAddMode && this.id) {
      this.loadAllDataInParallel(Number(this.id));
    } else {
      this.getAllDropdownsListOfData();
    }

    // Capture initial state for change detection (Cancel button)
    this.setupDropdownSearches();

    // Capture initial state for change detection (Cancel button)
    setTimeout(() => {
      this.captureInitialState();
      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit(): void {
  }

  private setupDropdownSearches() {
    this.companySearch$.pipe(
      debounceTime(500),
      // Only trigger if term OR type changed significantly
      distinctUntilChanged((prev, curr) => prev.term === curr.term && prev.type === curr.type),
      switchMap(({ term, type }) => {
        if (!term || term.trim().length === 0) return of({ type, data: null });

        if (type === 'pickup') this.isPickupCompanySearching = true;
        else this.isDeliveryCompanySearching = true;

        this.cdr.markForCheck();
        return this.http.get<any>(`${this.authService._liveApiUrl}/company/company-listing/?company_name=${encodeURIComponent(term)}&page=1`).pipe(
          map(data => ({ type, data })),
          catchError(() => of({ type, data: null }))
        );
      })
    ).subscribe(({ type, data }) => {
      this.isPickupCompanySearching = false;
      this.isDeliveryCompanySearching = false;
      let results = data?.addresses?.results || data?.companies?.results || data?.result?.results || data;
      if (!Array.isArray(results)) results = [];
      if (results && results.length > 0) {
        this.mergeNewCompanies(results, type);
      }
      this.cdr.markForCheck();
    });

    this.addressSearch$.pipe(
      debounceTime(500),
      distinctUntilChanged((prev, curr) => prev.term === curr.term && prev.type === curr.type),
      switchMap(({ term, type }) => {
        if (!term || term.trim().length === 0) return of({ type, data: null });

        if (type === 'pickup') this.isPickupAddressSearching = true;
        else this.isDeliveryAddressSearching = true;

        this.cdr.markForCheck();
        return this.addressService.addressSearchObservable('1', term).pipe(
          map(data => ({ type, data })),
          catchError(() => of({ type, data: null }))
        );
      })
    ).subscribe(({ type, data }) => {
      this.isPickupAddressSearching = false;
      this.isDeliveryAddressSearching = false;
      let results = data?.addresses?.results || data?.companies?.results || data?.result?.results || data;
      if (!Array.isArray(results)) results = [];
      if (results && results.length > 0) {
        this.mergeNewAddresses(results, type);
      }
      this.cdr.markForCheck();
    });
  }

  private mergeNewCompanies(newData: any[], type: 'pickup' | 'delivery') {
    newData.forEach(item => {
      const name = item.company || item.company_name || item.warehouse_name;
      if (name) {
        if (type === 'pickup' && !this.pickupCompanies.includes(name)) {
          this.pickupCompanies.push(name);
        } else if (type === 'delivery' && !this.deliveryCompanies.includes(name)) {
          this.deliveryCompanies.push(name);
        }

        if (!this.companiesList.find((c: any) => c.value === name)) {
          this.companiesList.push({ value: name, label: name });
        }
      }
    });
    if (type === 'pickup') this.filterPickupCompanies(false);
    else this.filterDeliveryCompanies(false);
  }

  private mergeNewAddresses(newData: any[], type: 'pickup' | 'delivery') {
    if (!this.addressData) this.addressData = [];
    newData.forEach(item => {
      if (item.address) {
        if (type === 'pickup' && !this.pickupAddresses.includes(item.address)) {
          this.pickupAddresses.push(item.address);
          this.addressData.push(item);
        } else if (type === 'delivery' && !this.deliveryAddresses.includes(item.address)) {
          this.deliveryAddresses.push(item.address);
          this.addressData.push(item);
        }

        if (!this.data.find(d => d.label === item.address)) {
          this.data.push({ value: item.id, label: item.address });
        }
      }
    });
    if (type === 'pickup') this.filterPickupAddresses(false);
    else this.filterDeliveryAddresses(false);
  }

  getTime(milliseconds?: any) {
    if (milliseconds) {
      const currentDate = new Date();
      const hours = currentDate.getHours().toString().padStart(2, '0');
      const minutes = currentDate.getMinutes().toString().padStart(2, '0');
      const seconds = currentDate.getSeconds().toString().padStart(2, '0');
      const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');
      return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    } else {
      return new Date().toLocaleTimeString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
    }
  }

  Signaturereq(value: string, isChecked: boolean) {
    const currentPickupNote = this.orderForm.pickup.notes || '';
    const currentDelyNote = this.orderForm.delivery.notes || '';

    if (value === 'pickup') {
      this.orderForm.pickup.notes = isChecked
        ? (currentPickupNote ? 'Customer signature required.\n\n' + currentPickupNote : 'Customer signature required.')
        : currentPickupNote?.replace('Customer signature required.', '').trim();

      this.addOrderF.patchValue({
        pickup_note: this.orderForm.pickup.notes
      });
    }
    if (value === 'delivery') {
      this.orderForm.delivery.notes = isChecked
        ? (currentDelyNote ? 'Customer signature required.\n\n' + currentDelyNote : 'Customer signature required.')
        : currentDelyNote?.replace('Customer signature required.', '').trim();

      this.addOrderF.patchValue({
        dely_note: this.orderForm.delivery.notes
      });
    }
    this.cdr.markForCheck();
  }

  processDropdownData(data: any) {
    // Company list in - data[0]
    if (data && data[0]?.result) {
      this.companiesList = [];
      this.tempCompaniesList = [];
      this.pickupCompanies = [];
      this.deliveryCompanies = [];

      data[0]?.result?.results.forEach((data: any) => {
        this.companiesList.push({
          value: data?.company,
          label: data?.company,
        });
        this.tempCompaniesList.push({
          value: data?.company,
          label: data?.company,
        });
        this.pickupCompanies.push(data?.company);
        this.deliveryCompanies.push(data?.company);
      });
    }

    // Warehouse list - data[1]
    if (data && data[1]?.result) {
      this.warehouseList = [];
      data[1].result.results.forEach((element: any) => {
        if (element.is_main_localation) {
          this.warehouseData = element;
        }
        this.companiesList.push({
          value: this.toTitleCase(element.warehouse_name),
          label: element?.warehouse_name,
        });
        this.warehouseList.push({
          value: this.toTitleCase(element.warehouse_name),
          label: this.toTitleCase(element.warehouse_name),
        });
        this.pickupCompanies.push(element.warehouse_name);
        this.deliveryCompanies.push(element.warehouse_name);
      });
    }

    // Address list - data[2]
    this.addressData = data[2]?.result?.results;
    if (data[2]?.result) {
      this.data = [];
      this.pickupAddresses = [];
      this.deliveryAddresses = [];

      data[2]?.result?.results.forEach((data: any) => {
        this.data.push({
          value: data?.id,
          label: data?.address,
        });
        this.pickupAddresses.push(data?.address);
        this.deliveryAddresses.push(data?.address);
      });

      // if (!this.isAddMode) {
      //   this.orderDetail(this.route.snapshot.params['id']);
      // }
    }

    // Initialize filtered lists
    this.filteredPickupCompanies = [...this.pickupCompanies];
    this.filteredDeliveryCompanies = [...this.deliveryCompanies];
    this.filteredPickupAddresses = [...this.pickupAddresses];
    this.filteredDeliveryAddresses = [...this.deliveryAddresses];

    if (this.isAddMode) {
      this.loader = false;
    }
    this.cdr.markForCheck();
  }

  getAllDropdownsListOfData() {
    this.orderService.getAddOrderData().subscribe((data: any) => {
      this.processDropdownData(data);
    }, (err) => {
      this.globalLoader.hide();
      this.loader = false;
      this.authService.dataError(err);
      this.cdr.markForCheck();
    });
  }

  loadAllDataInParallel(id: number) {
    this.loader = true;
    forkJoin([
      this.orderService.getAddOrderData(),
      this.orderService.editOrder(id)
    ]).subscribe({
      next: (results: any[]) => {
        this.processDropdownData(results[0]);
        this.handleOrderDetailResponse(results[1]);
        this.loader = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.globalLoader.hide();
        this.loader = false;
        this.authService.dataError(err);
        this.cdr.markForCheck();
      }
    });
  }

  toTitleCase(str: string): string {
    if (!str) return '';
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  dateMomentObjFormat(d: any) {
    if (typeof d == 'object') {
      let date = d._d;
      return date.getFullYear() + '-' + this.padNumber(date.getMonth() + 1) + '-' + this.padNumber(date.getDate());
    } else {
      return d;
    }
  }

  dateFormat(d: any) {
    if (typeof d == 'object') {
      let date = d;
      return date.getFullYear() + '-' + this.padNumber(date.getMonth() + 1) + '-' + this.padNumber(date.getDate());
    } else {
      return d;
    }
  }

  padNumber(num: any) {
    return num < 10 ? '0' + num : num;
  }

  onKeyup(e: any) {
    if (this.isCheckedWarehous[0].pickup && e.target.id == 'pickup_company_name-search-field') {
      this.companiesList = JSON.parse(JSON.stringify(this.warehouseList));
    } else if (!this.isCheckedWarehous[0].pickup && e.target.id == 'pickup_company_name-search-field') {
      this.companiesList = JSON.parse(JSON.stringify(this.tempCompaniesList));
    }

    if (this.isCheckedWarehous[1].dely && e.target.id == 'dely_company_name-search-field') {
      this.companiesList = JSON.parse(JSON.stringify(this.warehouseList));
    } else if (!this.isCheckedWarehous[1].dely && e.target.id == 'dely_company_name-search-field') {
      this.companiesList = JSON.parse(JSON.stringify(this.tempCompaniesList));
    }

    if (!this.isCheckedWarehous[1].dely &&
      (e.target.id == 'dely_company_name-search-field' || e.target.id == 'pickup_company_name-search-field') &&
      !this.isCheckedWarehous[0].pickup) {
      this.companiesList = [...this.warehouseList, ...this.tempCompaniesList];
    }
  }

  // Mode toggle methods
  togglePickupMode(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.orderForm.pickup.mode = 'auto';
    } else {
      this.orderForm.delivery.mode = '';
      this.orderForm.pickup.mode = '';
      this.setNullPickupValue();
      this.changeStatus('pickup', true, 'click-from-ts');
    }
    if (this.orderForm.pickup.mode === 'auto') {
      this.isManualChecked = false;
      this.changeStatus('pickup', false, 'click-from-ts');
    }
  }

  toggleDeliveryMode(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.orderForm.delivery.mode = 'auto';
    } else {
      this.orderForm.pickup.mode = '';
      this.orderForm.delivery.mode = '';
      this.setNullDelyValue();
      this.changeStatus('to', true, 'click-from-ts');
    }
    if (this.orderForm.delivery.mode === 'auto') {
      this.isManualChecked1 = false;
      this.changeStatus('to', false, 'click-from-ts');
    }
  }
  toggleDeliveryModeManual(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.orderForm.delivery.mode = 'manual';
      this.orderForm.pickup.mode = 'manual';
      this.isCheckedWarehous[0].pickup = false;
      this.isCheckedWarehous[1].dely = false;
      this.ispickuptimetaken = false;
      this.isdelaytimetaken = false;
      this.isManualChecked1 = true;
      this.isManualChecked = true;
    }
    else {
      this.orderForm.delivery.mode = '';
      this.orderForm.pickup.mode = '';
      this.isCheckedWarehous[0].pickup = false;
      this.isCheckedWarehous[1].dely = false;
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = true;
      this.isManualChecked1 = false;
      this.isManualChecked = false;
    }
    this.setNullDelyValue();
    this.setNullPickupValue();
  }

  // Dropdown filter methods
  filterPickupCompanies(triggerSearch: boolean = true): void {
    const search = this.orderForm.pickup.company?.trimStart().toLowerCase() || '';
    this.filteredPickupCompanies = this.pickupCompanies.filter(c =>
      c.toLowerCase().includes(search)
    );
    if (this.filteredPickupCompanies.length > 0) {
      this.highlightedPickupIndex = 0;
    } else {
      this.highlightedPickupIndex = -1;
    }
    if (triggerSearch && search.length >= 1) {
      this.companySearch$.next({ term: search, type: 'pickup' });
    }
    this.companyName(null, 'pickup');
  }

  filterDeliveryCompanies(triggerSearch: boolean = true): void {
    const search = this.orderForm.delivery.company?.trimStart().toLowerCase() || '';
    this.filteredDeliveryCompanies = this.deliveryCompanies.filter(c =>
      c.toLowerCase().includes(search)
    );
    if (this.filteredDeliveryCompanies.length > 0) {
      this.highlightedIndex = 0;
    } else {
      this.highlightedIndex = -1;
    }
    if (triggerSearch && search.length >= 1) {
      this.companySearch$.next({ term: search, type: 'delivery' });
    }
    this.companyName(null, 'dely');
  }

  filterPickupAddresses(triggerSearch: boolean = true): void {
    const search = this.orderForm.pickup.address?.trimStart().toLowerCase() || '';
    this.filteredPickupAddresses = this.pickupAddresses.filter(a =>
      a.toLowerCase().includes(search)
    );
    if (this.filteredPickupAddresses.length > 0) {
      this.highlightedPickupAddressIndex = 0;
    } else {
      this.highlightedPickupAddressIndex = -1;
    }
    if (triggerSearch && search.length >= 1) {
      this.addressSearch$.next({ term: search, type: 'pickup' });
    }
    this.companyName(null, 'pickup');
  }

  filterDeliveryAddresses(triggerSearch: boolean = true): void {
    const search = this.orderForm.delivery.address?.trimStart().toLowerCase() || '';
    this.filteredDeliveryAddresses = this.deliveryAddresses.filter(a =>
      a.toLowerCase().includes(search)
    );
    if (this.filteredDeliveryAddresses.length > 0) {
      this.highlightedDeliveryAddressIndex = 0;
    } else {
      this.highlightedDeliveryAddressIndex = -1;
    }
    if (triggerSearch && search.length >= 1) {
      this.addressSearch$.next({ term: search, type: 'delivery' });
    }
    this.companyName(null, 'dely');
  }

  // Select from dropdown methods
  selectPickupCompany(company: string): void {
    this.orderForm.pickup.company = company;
    this.showPickupCompanyDropdown = false;
    this.highlightedPickupIndex = -1;
    delete this.errors['pickupCompany'];

    this.addOrderF.patchValue({
      pickup_company_name: company
    });

    this.companyName({ target: { value: company } }, 'pickup');
  }

  selectDeliveryCompany(company: string): void {
    this.orderForm.delivery.company = company;
    this.showDeliveryCompanyDropdown = false;
    this.highlightedIndex = -1;
    delete this.errors['deliveryCompany'];

    this.addOrderF.patchValue({
      dely_company_name: company
    });

    this.companyName({ target: { value: company } }, 'dely');
  }

  selectPickupAddress(address: string): void {
    this.orderForm.pickup.address = address;
    this.showPickupAddressDropdown = false;
    this.highlightedPickupAddressIndex = -1;
    delete this.errors['pickupAddress'];

    // Find the address ID from addressData
    const addressObj = this.addressData?.find((a: any) => a.address === address);
    if (addressObj) {
      this.addOrderF.patchValue({
        pickup_address: addressObj.id
      });
    }
    this.companyName({ target: { value: address } }, 'pickup');
  }

  selectDeliveryAddress(address: string): void {
    this.orderForm.delivery.address = address;
    this.showDeliveryAddressDropdown = false;
    this.highlightedDeliveryAddressIndex = -1;
    delete this.errors['deliveryAddress'];

    // Find the address ID from addressData
    const addressObj = this.addressData?.find((a: any) => a.address === address);
    if (addressObj) {
      this.addOrderF.patchValue({
        dely_address: addressObj.id
      });
    }
    this.companyName({ target: { value: address } }, 'dely');
  }

  loadMorePickupDelpu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.visiblePickupDelpuCount = Math.min(this.visiblePickupDelpuCount + 3, this.Delpu.length);
    this.cdr.markForCheck();
  }

  loadMoreDelyDelpu(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.visibleDelyDelpuCount = Math.min(this.visibleDelyDelpuCount + 3, this.Delpu.length);
    this.cdr.markForCheck();
  }

  selectPickupDelpu(val: number) {
    this.orderForm.pickup.firstDelivery = val;
    this.orderForm.delivery.firstDelivery = 0;
    this.addOrderF.patchValue({
      is_pickup_first_delivery: val,
      is_dely_first_delivery: 0
    });
    this.showPickupDelpuDropdown = false;
    this.cdr.markForCheck();
  }

  selectDelyDelpu(val: number) {
    this.orderForm.delivery.firstDelivery = val;
    this.orderForm.pickup.firstDelivery = 0;
    this.addOrderF.patchValue({
      is_dely_first_delivery: val,
      is_pickup_first_delivery: 0
    });
    this.showDelyDelpuDropdown = false;
    this.cdr.markForCheck();
  }

  // Character count methods
  updatePickupNotesCount(): void {
    this.pickupNotesRemaining = 200 - this.orderForm.pickup.notes.length;
    this.addOrderF.patchValue({
      pickup_note: this.orderForm.pickup.notes
    });
  }

  updateDeliveryNotesCount(): void {
    this.deliveryNotesRemaining = 200 - this.orderForm.delivery.notes.length;
    this.addOrderF.patchValue({
      dely_note: this.orderForm.delivery.notes
    });
  }

  // Capitalize contact names
  capitalizeContactName(event: any, section: 'pickup' | 'delivery'): void {
    const words = event.target.value.split(' ');
    const capitalized = words.map((word: string) => {
      if (word.length > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word;
    }).join(' ');

    if (section === 'pickup') {
      this.orderForm.pickup.contact = capitalized;
      this.addOrderF.patchValue({
        pickup_contact_name: capitalized
      });
    } else {
      this.orderForm.delivery.contact = capitalized;
      this.addOrderF.patchValue({
        dely_contact_name: capitalized
      });
    }
  }

  // Phone validation
  // validatePhone(event: any, section?: 'pickup' | 'delivery'): void {
  //   const originalValue = event.target.value;
  //   const cleanedValue = originalValue.replace(/[^0-9]/g, '');
  //   event.target.value = cleanedValue;

  //   if (section) {
  //     const isTenEights = cleanedValue === '8888888888';
  //     const contactField = section === 'pickup' ? 'pickup_contact_name' : 'dely_contact_name';

  //     if (isTenEights) {
  //       this.orderForm[section].contact = 'Customer';
  //       this.addOrderF.patchValue({
  //         [contactField]: 'Customer'
  //       });
  //     } else if (this.orderForm[section].contact === 'Customer') {
  //       this.orderForm[section].contact = '';
  //       this.addOrderF.patchValue({
  //         [contactField]: ''
  //       });
  //     }
  //   }
  // }
  validatePhone(event: any, section?: 'pickup' | 'delivery'): void {
    const originalValue = event.target.value;
    const cleanedValue = originalValue.replace(/[^0-9]/g, '');
    event.target.value = cleanedValue;

    if (section) {
      const contactField = section === 'pickup' ? 'pickup_contact_name' : 'dely_contact_name';

      let autoName = '';

      if (cleanedValue === '8888888888') {
        autoName = 'Customer';
      } else if (cleanedValue === '9999999999') {
        autoName = section === 'pickup' ? 'Shipping Dept' : 'Receiving Dept';
      }

      if (autoName) {
        this.orderForm[section].contact = autoName;
        this.addOrderF.patchValue({
          [contactField]: autoName
        });
      } else {
        // agar pehle auto-filled tha to clear kar do
        if (
          ['Customer', 'Shipping Dept', 'Receiving Dept'].includes(
            this.orderForm[section].contact
          )
        ) {
          this.orderForm[section].contact = '';
          this.addOrderF.patchValue({
            [contactField]: ''
          });
        }
      }
    }
  }

  onClickOfPickup(e: any) {
    if (this.isManualChecked || this.isManualChecked1) {
      this.ispickuptimetaken = false;
      this.isonClickOfPickupTriggered = false;
      return;
    }
    if (!this.isCheckedWarehous[0].pickup) {
      this.isdelaytimetaken = true;
      this.ispickuptimetaken = false;
      this.isonClickOfPickupTriggered = true;
      this.isonClickOfDelyTriggered = false;
      if (this.isAddMode) {
        this.changeStatus('to', false, 'click-from-ts');
      }
    }
    this.typeOfOrder = 'pickup';
  }

  onClickOfDely(e: any) {
    if (this.isManualChecked1 || this.isManualChecked) {
      this.isdelaytimetaken = false;
      this.isonClickOfPickupTriggered = false;
      return;
    }
    if (!this.isCheckedWarehous[1].dely) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = false;
      this.isonClickOfDelyTriggered = true;
      this.isonClickOfPickupTriggered = false;
      if (this.isAddMode) {
        this.changeStatus('pickup', this.isCheckedWarehous[1].dely, 'click-from-ts');
      }
    }
    this.typeOfOrder = 'dely';
  }

  getNextBusinessDay() {
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var date = new Date(new Date().toLocaleString("en-US", { timeZone: timezone }));
    do {
      date.setDate(date.getDate() + 1);
    } while (!(date.getDay() % 6))
    return date;
  }

  companyName(e: any, type: string) {
    const pickupComp = this.orderForm.pickup.company;
    const delyComp = this.orderForm.delivery.company;
    const pickupAddrText = this.orderForm.pickup.address;
    const delyAddrText = this.orderForm.delivery.address;

    const pickupAddrId = this.addressData?.find((a: any) => a.address === pickupAddrText)?.id;
    const delyAddrId = this.addressData?.find((a: any) => a.address === delyAddrText)?.id;

    if (type == 'dely') {
      if (delyComp && delyComp.trim() !== '' && delyAddrId && !this.isCheckedWarehous[1].dely) {
        this.getPreviousOrderDataForDely(type, delyComp, delyAddrId);
      } else {
        this.resetDelyFields();
      }
    } else if (type == 'pickup') {
      if (pickupComp && pickupComp.trim() !== '' && pickupAddrId && !this.isCheckedWarehous[0].pickup) {
        this.getPreviousOrderDataForDely(type, pickupComp, pickupAddrId);
      } else {
        this.resetPickupFields();
      }
    }
  }

  getPreviousOrderDataForDely(type: any, dComp: string, dAddr: string) {
    this.orderService.getOrderDatas(dComp, dAddr).subscribe((res: any) => {
      if (typeof res.result == 'object') {
        let orderData = res?.result;
        if (orderData.order_type == 'delivery') {
          this.patchFields(type, orderData, 'dely');
        } else {
          this.patchFields(type, orderData, 'pickup');
        }
      } else {
        if (type == 'dely') {
          this.resetDelyFields();
        } else {
          this.resetPickupFields();
        }
      }
    });
    this.validateNewUIForm()
  }

  resetDelyFields() {
    this.orderForm.delivery.contact = '';
    this.orderForm.delivery.email = '';
    this.orderForm.delivery.phone = '';
    this.orderForm.delivery.altPhone = '';
    this.orderForm.delivery.countryCode = this.countriescodes;

    this.addOrderF.patchValue({
      dely_contact_name: null,
      dely_email: null,
      dely_phone: null,
      dely_alt_phone: null,
      country_code: this.countriescodes,
    });
  }

  resetPickupFields() {
    this.orderForm.pickup.contact = '';
    this.orderForm.pickup.email = '';
    this.orderForm.pickup.phone = '';
    this.orderForm.pickup.altPhone = '';
    this.orderForm.pickup.countryCode = this.countriescodes;

    this.addOrderF.patchValue({
      pickup_contact_name: null,
      pickup_email: '',
      pickup_phone: null,
      pickup_alt_phone: null,
      country_code: this.countriescodes,
    });
  }

  patchFields(type: any, data: any, orderType: any) {
    if (type == 'dely') {
      this.resetDelyFields();
    } else {
      this.resetPickupFields();
    }

    let obj: any = {};

    var fcontactName = orderType + "_contact_name";
    var femail = orderType + "_email";
    var fphone = orderType + "_phone";
    var faltPhone = orderType + "_alt_phone";

    var contactName = type + "_contact_name";
    var email = type + "_email";
    var phone = type + "_phone";
    var altPhone = type + "_alt_phone";

    // Helper function to clean null values
    const cleanValue = (val: any) => {
      return (val === null || val === "null" || val === undefined) ? "" : val;
    };

    obj[contactName] = cleanValue(data[fcontactName]);
    obj[email] = cleanValue(data[femail]);
    obj[phone] = cleanValue(data[fphone]);
    obj[altPhone] = cleanValue(data[faltPhone]);
    obj["country_code"] = cleanValue(data["country_code"]);

    this.addOrderF.patchValue(obj);

    // Sync with orderForm
    if (type === 'pickup') {
      this.orderForm.pickup.contact = cleanValue(data[fcontactName]);
      this.orderForm.pickup.email = cleanValue(data[femail]);
      this.orderForm.pickup.phone = cleanValue(data[fphone]);
      this.orderForm.pickup.altPhone = cleanValue(data[faltPhone]);
      this.orderForm.pickup.countryCode = cleanValue(data["country_code"]);
    } else {
      this.orderForm.delivery.contact = cleanValue(data[fcontactName]);
      this.orderForm.delivery.email = cleanValue(data[femail]);
      this.orderForm.delivery.phone = cleanValue(data[fphone]);
      this.orderForm.delivery.altPhone = cleanValue(data[faltPhone]);
      this.orderForm.delivery.countryCode = cleanValue(data["country_code"]);
    }

    this.validateNewUIForm();
  }


  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
    addressType: string
  ): void {
    const dialogRef = this.dialog.open(AddAddressListingComponent, {
      width: '800px',
      enterAnimationDuration,
      exitAnimationDuration,
      data: {
        isCloseBtn: true
      },
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.addressService.addressSearchObservable(1, '').pipe(take(1)).subscribe(data => {
          const results = data?.result?.results || data;
          if (results && results.length > 0) {
            const type = (addressType === 'pickup') ? 'pickup' : 'delivery';
            this.mergeNewAddresses(results, type);
            const latest = results[0];
            if (type === 'pickup') {
              this.addOrderF.patchValue({ pickup_address: latest.id });
              this.orderForm.pickup.address = latest.address;
            } else {
              this.addOrderF.patchValue({ dely_address: latest.id });
              this.orderForm.delivery.address = latest.address;
            }
            this.cdr.markForCheck();
          }
        });
      }
    });
  }

  addNewAddress(section: 'pickup' | 'delivery'): void {
    this.openDialog('0ms', '0ms', section);
  }

  addressList(page: any) {
    this.addressService.addressSearch(page);
    this.address$ = this.addressService.getAddress();

    this.address$.subscribe((data: any) => {
      this.addressData = data?.result?.results;
      if (data?.result) {
        this.data = [];
        this.pickupAddresses = [];
        this.deliveryAddresses = [];

        data?.result?.results.forEach((data: any) => {
          this.data.push({
            value: data?.id,
            label: data?.address,
          });
          this.pickupAddresses.push(data?.address);
          this.deliveryAddresses.push(data?.address);
        });

        if (!this.isAddMode) {
          this.orderDetail(this.route.snapshot.params['id']);
        }

        this.filteredPickupAddresses = [...this.pickupAddresses];
        this.filteredDeliveryAddresses = [...this.deliveryAddresses];
      }
    });
  }

  orderDetail(id: number) {
    this.loader = true;
    this.orderService.editOrder(id).subscribe({
      next: (data: any) => this.handleOrderDetailResponse(data),
      error: (error) => {
        this.authService.dataError(error);
        this.loading = false;
        this.loader = false;
        this.cdr.markForCheck();
      }
    });
  }

  handleOrderDetailResponse(data: any) {
    if (this.authService.resultCodeError(data)) {
      this.loading = false;
      this.loader = false;
      this.cdr.markForCheck();
      return;
    }
    this.orderData = data?.result;

    if (this.orderData.is_pickup_warehouse) {
      this.isCheckedWarehous[1].dely = false;
      this.isCheckedWarehous[0].pickup = true;
      this.isPickupWareHouseEnabled = true;
      this.isDelyWareHouseEnabled = false;
      this.orderForm.pickup.mode = 'auto';
      this.addOrderF.controls['po'].clearValidators();
    } else if (this.orderData.is_dely_warehouse) {
      this.addOrderF.controls['order_no'].clearValidators();
      this.isCheckedWarehous[1].dely = true;
      this.isCheckedWarehous[0].pickup = false;
      this.isPickupWareHouseEnabled = false;
      this.isDelyWareHouseEnabled = true;
      this.orderForm.delivery.mode = 'auto';
    }

    const pickupNote =
      this.orderData?.pickup_note && this.orderData?.pickup_note !== 'null'
        ? `${this.orderData?.signature_required &&
          !this.orderData.pickup_note.includes('Customer signature required')
          ? 'Customer signature required.\n\n'
          : ''}${this.orderData.pickup_note}`.trim()
        : (this.orderData?.is_dely_warehouse === true &&
          this.orderData?.pickup_note === null &&
          this.orderData?.signature_required === true)
          ? 'Customer signature required.'
          : '';

    const delyNote =
      this.orderData?.dely_note && this.orderData?.dely_note !== 'null'
        ? `${this.orderData?.signature_required &&
          !this.orderData.dely_note.includes('Customer signature required')
          ? 'Customer signature required.\n\n'
          : ''}${this.orderData.dely_note}`.trim()
        : (this.orderData?.is_pickup_warehouse === true &&
          this.orderData?.dely_note === null &&
          this.orderData?.signature_required === true)
          ? 'Customer signature required.'
          : '';

    // Sync with new UI form
    this.orderForm.pickup.purchaseOrder = this.orderData?.po
      ? `${this.orderData.po}${this.orderData.pickup_multiple_order_ids
        ? `, ${this.orderData.pickup_multiple_order_ids.replace(/,\s+/g, ', ').trim()}`
        : ''}`
      : '';
    this.orderForm.pickup.company = this.orderData?.pickup_company_name || '';
    this.orderForm.pickup.date = this.convertToLocalDate(this.orderData?.pickup_date);
    this.orderForm.pickup.time = this.getFirstPart(this.orderData?.pickup_time) || '';

    // Removed artificial 3s delay
    this.onPickupTimeSet(this.getFirstPart(this.orderData?.pickup_time) || '');

    this.orderForm.pickup.contact = this.orderData?.pickup_contact_name || '';
    this.orderForm.pickup.email = this.orderData?.pickup_email || '';
    this.orderForm.pickup.phone = this.orderData?.pickup_phone || '';
    this.orderForm.pickup.altPhone = this.orderData?.pickup_alt_phone === 'null' ||
      this.orderData?.pickup_alt_phone === null ||
      this.orderData?.pickup_alt_phone === undefined || this.orderData?.pickup_alt_phone === 'undefined'
      ? ''
      : this.orderData.pickup_alt_phone;
    let initialPickupFirstDelivery = Number(this.orderData?.is_pickup_first_delivery) || 0;
    let initialDelyFirstDelivery = Number(this.orderData?.is_dely_first_delivery) || 0;

    // Invariant: both can be 0, but never both > 0
    if (initialPickupFirstDelivery > 0 && initialDelyFirstDelivery > 0) {
      if (this.orderData?.order_type === 'pickup' || this.orderData?.is_dely_warehouse) {
        initialDelyFirstDelivery = 0;
      } else {
        initialPickupFirstDelivery = 0;
      }
    }

    this.orderForm.pickup.notes = pickupNote;
    this.orderForm.pickup.timeInterval = this.orderData?.pickup_time_interval || '';
    this.orderForm.pickup.signatureRequired = this.orderData?.pickup_signature_required || false;
    this.orderForm.pickup.firstDelivery = initialPickupFirstDelivery;
    this.orderForm.pickup.countryCode = this.orderData?.country_code || localStorage.getItem('countryCode') || '+1';
    this.orderForm.pickup.address = this.orderData?.pickup_address.address;
    this.orderForm.delivery.orderNumber = this.orderData?.order_no
      ? `${this.orderData.order_no}${this.orderData.dely_multiple_order_ids
        ? `, ${this.orderData.dely_multiple_order_ids.replace(/,\s+/g, ', ').trim()}`
        : ''}`
      : '';
    this.orderForm.delivery.company = this.orderData?.dely_company_name || '';
    this.orderForm.delivery.date = this.convertToLocalDate(this.orderData?.dely_date);
    this.orderForm.delivery.time = this.getFirstPart(this.orderData?.dely_time) || '';
    this.orderForm.delivery.contact = this.orderData?.dely_contact_name || '';
    this.orderForm.delivery.email = this.orderData?.dely_email || '';
    this.orderForm.delivery.phone = this.orderData?.dely_phone?.replace('+1', '') || '';
    this.orderForm.delivery.altPhone =
      this.orderData?.dely_alt_phone === 'null' ||
        this.orderData?.dely_alt_phone === null ||
        this.orderData?.dely_alt_phone === undefined || this.orderData?.dely_alt_phone === 'undefined'
        ? ''
        : this.orderData.dely_alt_phone;
    this.orderForm.delivery.notes = delyNote;
    this.orderForm.delivery.timeInterval = this.orderData?.dely_time_interval || '';
    this.orderForm.delivery.signatureRequired = this.orderData?.dely_signature_required || false;
    this.orderForm.delivery.firstDelivery = initialDelyFirstDelivery;
    this.orderForm.delivery.countryCode = this.orderData?.country_code || localStorage.getItem('countryCode') || '+1';
    this.orderForm.delivery.address = this.orderData?.dely_address.address;

    this.addOrderF.patchValue({
      po: this.orderData?.po || '',
      pickup_company_name: this.orderData?.pickup_company_name,
      pickup_address: this.orderData?.pickup_address?.id,
      is_pickup_warehouse: this.orderData.is_pickup_warehouse,
      pickup_date: this.convertToLocalDate(this.orderData?.pickup_date),
      pickup_time: this.getFirstPart(this.orderData?.pickup_time),
      pickup_contact_name: this.orderData?.pickup_contact_name,
      pickup_email: this.orderData?.pickup_email,
      pickup_phone: this.orderData?.pickup_phone,
      pickup_alt_phone: this.orderData?.pickup_alt_phone,
      pickup_note: pickupNote,
      dely_company_name: this.orderData?.dely_company_name,
      dely_address: this.orderData?.dely_address?.id,
      is_dely_warehouse: this.orderData?.is_dely_warehouse,
      dely_date: this.convertToLocalDate(this.orderData?.dely_date),
      dely_time: this.getFirstPart(this.orderData?.dely_time),
      dely_contact_name: this.orderData?.dely_contact_name,
      dely_email: this.orderData?.dely_email,
      dely_phone: this.orderData?.dely_phone ? this.orderData?.dely_phone.replace('+1', '') : '',
      country_code: this.orderData?.country_code,
      dely_alt_phone: this.orderData?.dely_alt_phone,
      dely_note: delyNote,
      order_no: this.orderData?.order_no || '',
      pickup_time_interval: this.orderData?.pickup_time_interval,
      dely_time_interval: this.orderData?.dely_time_interval,
      pickup_signature_required: this.orderData?.pickup_signature_required,
      dely_signature_required: this.orderData?.dely_signature_required,
      is_pickup_first_delivery: initialPickupFirstDelivery,
      is_dely_first_delivery: initialDelyFirstDelivery,
    });

    if (this.orderData?.is_dely_warehouse == true) {
      this.ispickuptimetaken = false;
      this.isdelaytimetaken = true;
    }
    if (this.orderData?.is_pickup_warehouse == true) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = false;
    }

    if (this.orderData?.is_dely_warehouse == false && this.orderData?.is_pickup_warehouse == false) {
      this.ispickuptimetaken = false;
      this.isdelaytimetaken = false;
      this.addOrderF.get('isManualChecked')?.setValue(true);
      this.addOrderF.get('isManualChecked1')?.setValue(true);
      this.isManualChecked1 = true;
      this.isManualChecked = true;
      this.orderForm.pickup.mode = 'manual';
      this.orderForm.delivery.mode = 'manual';
    }
    this.loading = false;
    this.loader = false;

    // Capture loaded state for change detection
    setTimeout(() => {
      this.captureInitialState();
      this.cdr.markForCheck();
    });

    this.cdr.markForCheck();
  }

  convertToLocalDate(utcDateString: string | null): string {
    if (!utcDateString) {
      return '';
    }
    const datePipe = new DatePipe('en-US');
    const utcDate = new Date(utcDateString);
    return datePipe.transform(utcDate, 'yyyy-MM-dd') || '';
  }

  getFirstPart(time: string | null): string | undefined {
    if (!time || time.trim() === "0") {
      return undefined;
    }

    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      const [hours, minutes] = time.split(":").map(Number);
      let period = "AM";
      let displayHour = hours % 12 || 12;
      if (hours >= 12) {
        period = "PM";
      }
      return `${displayHour}:${minutes.toString().padStart(2, "0")} ${period}`;
    }

    const parts = time.split(" ");
    const value = parseFloat(parts[0]);
    const unit = parts[1]?.toLowerCase();

    if (!unit) {
      return undefined;
    }

    let totalMinutes: number;

    if (unit === "hours" || unit === "hour" || unit === "hrs" || unit === "hr") {
      totalMinutes = Math.floor(value * 60);
    } else if (unit === "days" || unit === "day") {
      totalMinutes = Math.floor(value * 24 * 60);
    } else if (unit === "minutes" || unit === "minute" || unit === "mins" || unit === "min") {
      totalMinutes = Math.floor(value);
    } else {
      return undefined;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    let period = "AM";
    let displayHour = hours % 12 || 12;
    if (hours >= 12) {
      period = "PM";
    }
    return `${displayHour}:${minutes.toString().padStart(2, "0")} ${period}`;
  }

  isAlphaNumeric(event: KeyboardEvent, inputType: string) {
    const inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value;
    const currentPos = inputElement.selectionStart ?? 0;

    if (event.ctrlKey) {
      const allowedKeys = ['a', 'c', 'v', 'x', 'z'];
      if (allowedKeys.includes(event.key.toLowerCase())) {
        return;
      }
    }

    if (event.key === 'Backspace' || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
      return;
    }

    // if (event.key === ' ' || event.key === 'Tab') {
    //   event.preventDefault();
    //   return;
    // }

    const disallowedSymbols = /[^a-zA-Z0-9*,]/;
    if (disallowedSymbols.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (inputType === 'PO' || inputType === 'ON') {
      if (event.key === ',') {
        event.preventDefault();
        inputValue = inputValue.slice(0, currentPos) + ', ' + inputValue.slice(currentPos);
        this.updateFormControl(inputType, inputValue);
        setTimeout(() => {
          inputElement.setSelectionRange(currentPos + 2, currentPos + 2);
        }, 0);
        return;
      }

      if (event.key === '*') {
        event.preventDefault();
        inputValue = inputValue.slice(0, currentPos) + '*' + inputValue.slice(currentPos);
        this.updateFormControl(inputType, inputValue);
        setTimeout(() => {
          inputElement.setSelectionRange(currentPos + 1, currentPos + 1);
        }, 0);
        return;
      }

      if (/^[a-zA-Z0-9]$/.test(event.key)) {
        setTimeout(() => {
          let formattedValue = inputElement.value;
          formattedValue = formattedValue.replace(/,(?!\s)/g, ', ');
          formattedValue = formattedValue.replace(/\s+/g, ' ');
          this.updateFormControl(inputType, formattedValue);
          inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
          if (inputElement.scrollWidth > inputElement.clientWidth) {
            inputElement.scrollLeft = inputElement.scrollWidth;
          }
        }, 0);
        return;
      }
    }
  }

  updateFormControl(inputType: string, formattedValue: string) {
    if (inputType === 'PO') {
      this.orderForm.pickup.purchaseOrder = formattedValue;
      this.addOrderF.patchValue({
        po: formattedValue
      }, { emitEvent: false });
    } else if (inputType === 'ON') {
      this.orderForm.delivery.orderNumber = formattedValue;
      this.addOrderF.patchValue({
        order_no: formattedValue
      }, { emitEvent: false });
    }
  }

  setPickupWarehouse(e: any) {
    if (e.target.checked) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = false;
      this.addOrderF.patchValue({
        pickup_address: this.warehouseData?.address?.id,
      });
    } else {
      this.ispickuptimetaken = false;
      this.isdelaytimetaken = true;
      this.addOrderF.patchValue({ pickup_address: null });
      this.addOrderF.patchValue({ dely_address: null });
    }
    if (!this.isDelyWareHouseEnabled && !this.isPickupWareHouseEnabled) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = true;
    }
  }

  setDelyWarehouse(e: any) {
    if (e.target.checked) {
      this.isdelaytimetaken = true;
      this.ispickuptimetaken = false;
      this.addOrderF.patchValue({
        dely_address: this.warehouseData?.address?.id,
      });
    } else {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = false;
      this.addOrderF.patchValue({ pickup_address: null });
      this.addOrderF.patchValue({ dely_address: null });
    }
    if (!this.isDelyWareHouseEnabled && !this.isPickupWareHouseEnabled) {
      this.ispickuptimetaken = true;
      this.isdelaytimetaken = true;
    }
  }

  getCurrentTime() {
    this.currentTime = this.getTime();
  }

  getFormattedDate(dateString: any) {
    const date = moment(dateString);
    const utcDate = date.utc();
    const formattedDate = utcDate.format('YYYY-MM-DDTHH:mm:ss.SSS') + "+00";
    return formattedDate;
  }

  onCountryCodeChange(code: string) {
    if (code) {
      this.orderForm.pickup.countryCode = code;
      this.orderForm.delivery.countryCode = code;
      this.addOrderF.patchValue({ country_code: code });
      
      // Update shared service for session-wide sync (other screens like Bulk Add)
      // but NOT the backend profile
      this.shareddta.updateCountryCode(code);
    }
  }

  // New UI submit method that syncs with old functionality
  submitOrder(): void {
    // Sync orderForm to addOrderF before validation
    this.syncOrderFormToFormGroup();
    this.isSubmitted = true;
    if (!this.validateNewUIForm()) {
      console.log('Form validation failed:', this.errors);
      return;
    }

    this.handleSubmit();
  }

  validateNewUIForm(): boolean {
    this.errors = {};
    let isValid = true;

    // Pickup validation this.orderForm.pickup.purchaseOrder?.trim()
    if (this.orderForm.pickup.mode === 'auto' && !this.orderForm.delivery.orderNumber?.trim()) {
      this.errors['orderNumber'] = 'Order Number is required';
      isValid = false;
    }
    if (this.orderForm.pickup.mode === 'manual' && !this.orderForm.pickup.purchaseOrder?.trim()) {
      this.errors['orderNumber'] = 'Order Number is required';
      isValid = false;
    }
    if (this.orderForm.pickup.mode === '' && !this.orderForm.delivery.orderNumber?.trim() && !this.orderForm.pickup.company.trim()) {
      this.errors['orderNumber'] = 'Order Number is required';
      isValid = false;
    }
    if (!this.orderForm.pickup.company.trim()) {
      this.errors['pickupCompany'] = 'Company name is required';
      isValid = false;
    }

    if (!this.orderForm.pickup.address.trim()) {
      this.errors['pickupAddress'] = 'Pickup address is required';
      isValid = false;
    }

    if (!this.orderForm.pickup.date) {
      this.errors['pickupDate'] = 'Date is required';
      isValid = false;
    }

    if (!this.orderForm.pickup.contact.trim()) {
      this.errors['pickupContact'] = 'Contact name is required';
      isValid = false;
    }

    // if (!this.orderForm.pickup.email.trim()) {
    //   this.errors['pickupEmail'] = 'Email is required';
    //   isValid = false;
    // } 
    // else if (!this.validateEmail(this.orderForm.pickup.email)) {
    //   this.errors['pickupEmail'] = 'Valid email is required';
    //   isValid = false;
    // }

    if (!this.orderForm.pickup.phone.trim()) {
      this.errors['pickupPhone'] = 'Phone is required';
      isValid = false;
    } else if (this.orderForm.pickup.phone.length !== 10) {
      this.errors['pickupPhone'] = 'Phone must be 10 digits';
      isValid = false;
    }

    if (this.orderForm.pickup.altPhone && this.orderForm.pickup.altPhone.length !== 10) {
      this.errors['pickupAltPhone'] = 'Phone must be 10 digits';
      isValid = false;
    }

    // Delivery validation
    if (this.orderForm.delivery.mode === 'auto' && !this.orderForm.pickup.purchaseOrder?.trim()) {
      this.errors['purchaseOrder'] = 'Purchase Order is required';;
      isValid = false;
    }
    if (this.orderForm.delivery.mode === 'manual' && !this.orderForm.delivery.orderNumber?.trim()) {
      this.errors['purchaseOrder'] = 'Purchase Order is required';;
      isValid = false;
    }
    if (this.orderForm.delivery.mode === '' && !this.orderForm.pickup.purchaseOrder?.trim() && !this.orderForm.delivery.company.trim()) {
      this.errors['purchaseOrder'] = 'Purchase Order is required';;
      isValid = false;
    }

    if (!this.orderForm.delivery.company.trim()) {
      this.errors['deliveryCompany'] = 'Company name is required';
      isValid = false;
    }

    if (!this.orderForm.delivery.address.trim()) {
      this.errors['deliveryAddress'] = 'Delivery address is required';
      isValid = false;
    }

    if (!this.orderForm.delivery.date) {
      this.errors['deliveryDate'] = 'Date is required';
      isValid = false;
    }

    if (!this.orderForm.delivery.contact.trim()) {
      this.errors['deliveryContact'] = 'Contact name is required';
      isValid = false;
    }

    // if (!this.orderForm.delivery.email.trim()) {
    //   this.errors['deliveryEmail'] = 'Email is required';
    //   isValid = false;
    // } 
    // else if (!this.validateEmail(this.orderForm.delivery.email)) {
    //   this.errors['deliveryEmail'] = 'Valid email is required';
    //   isValid = false;
    // }

    if (!this.orderForm.delivery.phone.trim()) {
      this.errors['deliveryPhone'] = 'Phone is required';
      isValid = false;
    } else if (this.orderForm.delivery.phone.length !== 10) {
      this.errors['deliveryPhone'] = 'Phone must be 10 digits';
      isValid = false;
    }

    if (this.orderForm.delivery.altPhone && this.orderForm.delivery.altPhone.length !== 10) {
      this.errors['deliveryAltPhone'] = 'Phone must be 10 digits';
      isValid = false;
    }

    this.cdr.markForCheck();
    return isValid;
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  syncOrderFormToFormGroup() {
    // Find address IDs from addressData but don't overwrite if we already have a valid ID matched to the text
    const currentPickupAddrId = this.addOrderF.get('pickup_address')?.value;
    const currentDelyAddrId = this.addOrderF.get('dely_address')?.value;
    
    const pickupAddressObjFromList = this.addressData?.find((a: any) => a.address === this.orderForm.pickup.address);
    const delyAddressObjFromList = this.addressData?.find((a: any) => a.address === this.orderForm.delivery.address);

    const finalPickupId = pickupAddressObjFromList?.id || currentPickupAddrId || '';
    const finalDelyId = delyAddressObjFromList?.id || currentDelyAddrId || '';

    // Enforce mutual exclusivity guard before syncing to form group
    let pickupFirstDelivery = Number(this.orderForm.pickup.firstDelivery) || 0;
    let delyFirstDelivery = Number(this.orderForm.delivery.firstDelivery) || 0;

    if (pickupFirstDelivery > 0 && delyFirstDelivery > 0) {
      if (this.isCheckedWarehous[1].dely || this.orderData?.order_type === 'pickup') {
        delyFirstDelivery = 0;
      } else {
        pickupFirstDelivery = 0;
      }
      this.orderForm.pickup.firstDelivery = pickupFirstDelivery;
      this.orderForm.delivery.firstDelivery = delyFirstDelivery;
    }

    this.addOrderF.patchValue({
      po: this.orderForm.pickup.purchaseOrder,
      pickup_company_name: this.orderForm.pickup.company,
      pickup_address: finalPickupId,
      pickup_date: this.orderForm.pickup.date,
      pickup_time: this.orderForm.pickup.time,
      pickup_contact_name: this.orderForm.pickup.contact,
      pickup_email: this.orderForm.pickup.email,
      pickup_phone: this.orderForm.pickup.phone,
      pickup_alt_phone: this.orderForm.pickup.altPhone,
      pickup_note: this.orderForm.pickup.notes,
      pickup_time_interval: this.orderForm.pickup.timeInterval,
      pickup_signature_required: this.orderForm.pickup.signatureRequired,
      is_pickup_first_delivery: pickupFirstDelivery,

      order_no: this.orderForm.delivery.orderNumber,
      dely_company_name: this.orderForm.delivery.company,
      dely_address: finalDelyId,
      dely_date: this.orderForm.delivery.date,
      dely_time: this.orderForm.delivery.time,
      dely_contact_name: this.orderForm.delivery.contact,
      dely_email: this.orderForm.delivery.email,
      dely_phone: this.orderForm.delivery.phone,
      dely_alt_phone: this.orderForm.delivery.altPhone,
      dely_note: this.orderForm.delivery.notes,
      dely_time_interval: this.orderForm.delivery.timeInterval,
      dely_signature_required: this.orderForm.delivery.signatureRequired,
      is_dely_first_delivery: delyFirstDelivery,

      country_code: this.orderForm.pickup.countryCode,
      is_pickup_warehouse: this.isCheckedWarehous[0].pickup,
      is_dely_warehouse: this.isCheckedWarehous[1].dely,
      isManualChecked: this.isManualChecked,
      isManualChecked1: this.isManualChecked1
    });
  }

  async handleSubmit() {
    this.isSubmitted = true;
    if (!this.isAddMode) {
      this.minDate = null;
    }

    this.addOrderF.patchValue({
      is_pickup_warehouse: this.isCheckedWarehous[0].pickup,
      is_dely_warehouse: this.isCheckedWarehous[1].dely,
    });

    if (this.dely_company_name) {
      this.addOrderF.patchValue({ dely_company_name: this.dely_company_name });
    }
    if (this.pickup_company_name) {
      this.addOrderF.patchValue({ pickup_company_name: this.pickup_company_name });
    }
    
    // Ensure emails are not null
    const pickupEmail = this.addOrderF.get('pickup_email')?.value;
    const delyEmail = this.addOrderF.get('dely_email')?.value;
    if (pickupEmail == null) this.addOrderF.patchValue({ pickup_email: '' });
    if (delyEmail == null) this.addOrderF.patchValue({ dely_email: '' });

    if (this.addOrderF.invalid) {
      console.warn('Form validation failed. Invalid controls:', 
        Object.keys(this.addOrderF.controls).filter(key => this.addOrderF.controls[key].invalid)
      );
      this.cdr.detectChanges();
      return;
    }

    this.loading = true;
    this.cdr.detectChanges();
    const formData = new FormData();

    for (let i in this.addOrderF.value) {
      const value = this.addOrderF.value[i];

      if (value instanceof File) {
        formData.append(i, value, value.name);
      } else if (value instanceof Blob) {
        // agar sirf Blob hai, naam manually set karo
        formData.append(i, value, 'file');
      } else {
        // baki fields
        if (i === 'pickup_time') {
          formData.append(i, this.timeConverter.transform(value, '12-24'));
        } else if (i === 'dely_time') {
          formData.append(i, this.timeConverter.transform(value, '12-24'));
        } else if (i === 'pickup_date') {
          const c = this.dateMomentObjFormat(value) + " " + this.getTime(true);
          formData.append(i, this.getFormattedDate(c));
        } else if (i === 'dely_date') {
          const c = this.dateMomentObjFormat(value) + " " + this.getTime(true);
          formData.append(i, this.getFormattedDate(c));
        } else {
          if (i === 'pickup_email' || i === 'dely_email') {
            formData.append(i, value || '');
          } else if (i === 'pickup_note' || i === 'dely_note') {
            formData.append(i, value !== undefined ? value : '');
          } else if (value?.toString() !== '') {
            formData.append(i, value);
          }
        }
      }
    }


    if (this.addOrderF.value.is_dely_warehouse === false && this.addOrderF.value.is_pickup_warehouse === false) {
      this.allow_order_merge = 'false';
    }
    formData.append('allow_order_merge', this.allow_order_merge);

    if (this.isAddMode) {
      this.orderService.orderAdd(formData).subscribe(
        (data: any) => {
          if (data.resultCode === '1') {
            this.toast.show('success', data.resultDescription);
            localStorage.removeItem('ordersCache');
            localStorage.removeItem('arkiveOrdersCache');
            localStorage.removeItem('nextPageUrl');
            localStorage.removeItem('arkiveNextPageUrl');
            localStorage.setItem('isSearchApplied', 'true');
            localStorage.setItem('fromOrderDetail', 'false');
            this.loading = false;
            this.page = 0;
            localStorage.setItem('pageIndex', String(this.page));
            this.cdr.markForCheck();
            this.initialFormState = JSON.stringify(this.orderForm);
            setTimeout(() => {
              location.reload();
            }, 500);
          }
          if (data.resultCode === '0') {
            if (data.add_star || data.is_merge) {
              this.loading = false;
              this.openErrorModal(data.errorMessage, data.add_star, data.is_merge, data.current_order_no);
            } else {
              if (data.errorMessage) {
                this.toast.show('error', data.errorMessage);
                this.loading = false;
              }
            }
            this.cdr.markForCheck();
          }
          if (data.resultCode === '4') {
            this.authService.doLogout();
            this.toast.show('success', 'Logout!');
            this.cdr.markForCheck();
          }
        },
        (error) => {
          this.authService.dataError(error);
          this.loading = false;
          this.cdr.markForCheck();
        }
      );
    } else {
      if (!this.addOrderF.value.order_no || this.addOrderF.value.order_no.trim() === '') {
        formData.append('order_no', '');
      }

      if (!this.addOrderF.value.po || this.addOrderF.value.po.trim() === '') {
        formData.append('po', '');
      }

      this.orderService.orderEdit(this.id, formData).subscribe(
        (data: any) => {
          if (data.resultCode === '1') {
            this.toast.show('success', data.resultDescription);

            // 🔹 INTELLIGENT CACHE PATCHING
            const cachedOrdersJson = localStorage.getItem('ordersCache');
            if (cachedOrdersJson) {
              try {
                const orders = JSON.parse(cachedOrdersJson);
                const index = orders.findIndex((o: any) => o.id == this.id);
                if (index !== -1 && data.result) {
                  // Update in-place to preserve list order and metadata
                  orders[index] = { ...orders[index], ...data.result };
                  localStorage.setItem('ordersCache', JSON.stringify(orders));
                  console.log('OrderSync: Cache patched for ID', this.id);
                }
              } catch (e) {
                console.error('OrderSync: Failed to patch cache', e);
              }
            }

            localStorage.removeItem('arkiveOrdersCache');
            localStorage.removeItem('updatedOrder');
            localStorage.removeItem('arkiveNextPageUrl');
            localStorage.setItem('isSearchApplied', 'true');

            // 🔹 PRESERVE STATE (Uniform Return Flow)
            localStorage.setItem('fromOrderDetail', 'true');
            this.initialFormState = JSON.stringify(this.orderForm);
            this.location.back();
            if (this.fromDetail) {
              localStorage.removeItem('vieworderdetailid');
            }
            this.loading = false;
            this.cdr.markForCheck();
          }
          if (data.resultCode === '0') {
            if (data.add_star || data.is_merge) {
              this.loading = false;
              this.openErrorModal(data.errorMessage, data.add_star, data.is_merge, data.current_order_no);
            } else {
              if (data.errorMessage) {
                this.toast.show('error', data.errorMessage);
                this.loading = false;
              }
            }
            this.cdr.markForCheck();
          }
          if (data.resultCode === '4') {
            this.authService.doLogout();
            this.toast.show('success', 'Logout!');
            this.cdr.markForCheck();
          }
        },
        (error) => {
          this.authService.dataError(error);
          this.loading = false;
          this.cdr.markForCheck();
        }
      );
    }
  }

  changeStatus(name: string, value: boolean, clickType?: string) {
    this.allow_order_merge = 'true';

    if (name == 'to') {
      if (value) {
        this.isCheckedWarehous[1].dely = false;
      } else if (this.isCheckedWarehous[0].pickup) {
        this.isCheckedWarehous[1].dely = true;
        this.orderForm.delivery.mode = "auto";
        this.isCheckedWarehous[0].pickup = false;
        this.orderForm.pickup.mode = "";
      } else if (!value) {
        this.isCheckedWarehous[1].dely = true;
        this.orderForm.delivery.mode = "auto";
      }
    } else {
      if (value) {
        this.isCheckedWarehous[0].pickup = false;
      } else if (this.isCheckedWarehous[1].dely) {
        this.isCheckedWarehous[0].pickup = true;
        this.isCheckedWarehous[1].dely = false;
        this.orderForm.pickup.mode = "auto";
        this.orderForm.delivery.mode = "";
      } else if (!value) {
        this.isCheckedWarehous[0].pickup = true;
        this.orderForm.pickup.mode = "auto";
      }
    }

    if (this.isCheckedWarehous[0].pickup) {
      // Warehouse is Pickup -> Order is Delivery to customer
      // Transfer priority from pickup to delivery (Option A), reset pickup to 0
      const currentPickupPriority = Number(this.orderForm.pickup.firstDelivery) || Number(this.addOrderF.get('is_pickup_first_delivery')?.value) || 0;
      const currentDelyPriority = Number(this.orderForm.delivery.firstDelivery) || Number(this.addOrderF.get('is_dely_first_delivery')?.value) || 0;
      const priorityToKeep = currentPickupPriority > 0 ? currentPickupPriority : currentDelyPriority;

      // Always clear the opposite side (Delivery) on first click when switching to Pickup warehouse
      this.setNullDelyValue();

      this.orderForm.delivery.firstDelivery = priorityToKeep;
      this.orderForm.pickup.firstDelivery = 0;

      this.isPickupWareHouseEnabled = true;
      this.isDelyWareHouseEnabled = false;
      this.companiesList = [...this.warehouseList, ...this.tempCompaniesList];

      this.addOrderF.patchValue({
        pickup_address: this.warehouseData?.address?.id,
        pickup_company_name: this.warehouseData?.warehouse_name,
        pickup_contact_name: this.warehouseData?.contact_name,
        pickup_phone: this.warehouseData?.phone ? this.warehouseData?.phone.replace('+1', '') : '',
        pickup_email: this.warehouseData?.email,
        pickup_alt_phone: this.warehouseData?.alt_phone ? this.warehouseData?.alt_phone.replace('+1', '') : '',
        country_code: this.warehouseData?.country_code,
        dely_email: '',
        is_dely_first_delivery: priorityToKeep,
        is_pickup_first_delivery: 0,
      });

      // Sync with orderForm IMMEDIATELY
      this.orderForm.pickup.company = this.warehouseData?.warehouse_name;
      this.orderForm.pickup.contact = this.warehouseData?.contact_name;
      this.orderForm.pickup.phone = this.warehouseData?.phone?.replace('+1', '');
      this.orderForm.pickup.email = this.warehouseData?.email;
      this.orderForm.pickup.altPhone = this.warehouseData?.alt_phone?.replace('+1', '');
      this.orderForm.pickup.countryCode = this.warehouseData?.country_code;
      this.orderForm.pickup.address = this.warehouseData?.address.address;
      this.orderForm.pickup.mode = "auto";
      this.orderForm.delivery.mode = "";
      if(this.require_delivery_signature){
      this.orderForm.delivery.signatureRequired = true;
      this.orderForm.delivery.notes = 'Customer signature required.';
      }
      this.validateNewUIForm();
      this.cdr.markForCheck();
    } else if (this.isCheckedWarehous[1].dely) {
      // Warehouse is Delivery -> Order is Pickup from customer
      // Transfer priority from delivery to pickup (Option A), reset delivery to 0
      const currentDelyPriority = Number(this.orderForm.delivery.firstDelivery) || Number(this.addOrderF.get('is_dely_first_delivery')?.value) || 0;
      const currentPickupPriority = Number(this.orderForm.pickup.firstDelivery) || Number(this.addOrderF.get('is_pickup_first_delivery')?.value) || 0;
      const priorityToKeep = currentDelyPriority > 0 ? currentDelyPriority : currentPickupPriority;

      // Always clear the opposite side (Pickup) on first click when switching to Delivery warehouse
      this.setNullPickupValue();

      this.orderForm.pickup.firstDelivery = priorityToKeep;
      this.orderForm.delivery.firstDelivery = 0;

      this.isPickupWareHouseEnabled = false;
      this.isDelyWareHouseEnabled = true;
      this.companiesList = [...this.warehouseList, ...this.tempCompaniesList];

      this.addOrderF.patchValue({
        dely_address: this.warehouseData?.address?.id,
        dely_company_name: this.warehouseData?.warehouse_name,
        dely_contact_name: this.warehouseData?.contact_name,
        dely_email: this.warehouseData?.email,
        dely_phone: this.warehouseData?.phone ? this.warehouseData?.phone.replace('+1', '') : '',
        dely_alt_phone: this.warehouseData?.alt_phone ? this.warehouseData?.alt_phone.replace('+1', '') : '',
        country_code: this.warehouseData?.country_code,
        pickup_email: '',
        order_no: '',
        is_pickup_first_delivery: priorityToKeep,
        is_dely_first_delivery: 0,
      });

      // Sync with orderForm IMMEDIATELY
      this.orderForm.delivery.company = this.warehouseData?.warehouse_name;
      this.orderForm.delivery.contact = this.warehouseData?.contact_name;
      this.orderForm.delivery.email = this.warehouseData?.email;
      this.orderForm.delivery.phone = this.warehouseData?.phone?.replace('+1', '');
      this.orderForm.delivery.altPhone = this.warehouseData?.alt_phone?.replace('+1', '');
      this.orderForm.delivery.countryCode = this.warehouseData?.country_code;
      this.orderForm.delivery.address = this.warehouseData?.address.address;
      this.orderForm.delivery.mode = "auto";
      this.orderForm.pickup.mode = "";
      this.orderForm.delivery.signatureRequired = false;
      this.orderForm.delivery.notes = '';
      this.validateNewUIForm();
      this.cdr.markForCheck();

      // if (clickType != 'click-from-ts') {
      //   setTimeout(() => {
      //     this.addOrderF.patchValue({
      //       pickup_company_name: null,
      //       pickup_address: null,
      //       pickup_contact_name: "Shipping dept",
      //       pickup_phone: '9999999999',
      //       pickup_email: 'shippingdept@gmaill.com',
      //     });
      //   }, 100);
      // }
    } else {
      this.isPickupWareHouseEnabled = false;
      this.isDelyWareHouseEnabled = false;
      this.setNullDelyValue();
      this.setNullPickupValue();
    }

    this.setTheValidatorsForPOON();
  }

  removeTime(val: string) {
    if (val == 'dely') {
      this.orderForm.delivery.time = '';
      this.addOrderF.patchValue({
        dely_time: '',
      });
    } else {
      this.orderForm.pickup.time = '';
      this.addOrderF.patchValue({
        pickup_time: '',
      });
    }
  }

  setTheValidatorsForPOON() {
    if (!this.isCheckedWarehous[1].dely) {
      this.addOrderF.controls['order_no'].setValidators([Validators.required]);
    } else {
      this.addOrderF.patchValue({ order_no: '' });
      this.orderForm.delivery.orderNumber = '';
      this.addOrderF.controls['order_no'].clearValidators();
    }
    if (!this.isCheckedWarehous[0].pickup) {
      this.addOrderF.controls['po'].setValidators([Validators.required]);
    } else {
      this.addOrderF.patchValue({ po: '' });
      this.orderForm.pickup.purchaseOrder = '';
      this.addOrderF.controls['po'].clearValidators();
    }

    this.addOrderF.controls['po'].updateValueAndValidity();
    this.addOrderF.controls['order_no'].updateValueAndValidity();
  }

  setNullPickupValue() {
    this.orderForm.pickup.company = '';
    this.orderForm.pickup.address = '';
    this.orderForm.pickup.contact = '';
    this.orderForm.pickup.phone = '';
    this.orderForm.pickup.email = '';
    this.orderForm.pickup.altPhone = '';
    this.orderForm.pickup.notes = '';
    this.orderForm.pickup.firstDelivery = 0;
    this.orderForm.pickup.countryCode = this.countriescodes;

    this.addOrderF.patchValue({
      pickup_address: null,
      pickup_company_name: null,
      pickup_contact_name: null,
      pickup_phone: null,
      pickup_email: '',
      pickup_alt_phone: null,
      country_code: this.countriescodes,
      pickup_signature_required: false,
      is_pickup_first_delivery: 0,
      dely_note: null,
    });
    this.pickup_company_name_placeholder = "Company Name";
  }

  setNullDelyValue() {
    this.orderForm.delivery.company = '';
    this.orderForm.delivery.address = '';
    this.orderForm.delivery.contact = '';
    this.orderForm.delivery.email = '';
    this.orderForm.delivery.phone = '';
    this.orderForm.delivery.altPhone = '';
    this.orderForm.delivery.notes = '';
    this.orderForm.delivery.firstDelivery = 0;
    this.orderForm.delivery.countryCode = this.countriescodes;
    this.orderForm.delivery.signatureRequired = false;
    this.addOrderF.patchValue({
      dely_address: null,
      dely_company_name: null,
      dely_contact_name: null,
      dely_email: null,
      dely_phone: null,
      dely_alt_phone: null,
      country_code: this.countriescodes,
      dely_signature_required: false,
      is_dely_first_delivery: 0,
      pickup_note: null,
    });
    this.dely_company_name_placeholder = "Company Name";
  }

  onWheel(event: any) {
    event.preventDefault();
  }

  onKeyPress(event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).value.length === 10) {
      event.preventDefault();
    }
  }



  normalMode() {
    this.authService.triggerAction();
  }

  ngOnDestroy() {
    this.isAddMode = true;
  }

  selectedFile: File | null = null;

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.csvFile = file;
      this.isCsvUploaded = false;
    } else {
      this.isCsvUploaded = true;
    }
  }

  uploadFile(): void {
    if (this.csvFile) {
      this.uploadloading = true;
      this.loading = true;

      const formData = new FormData();
      formData.append('file', this.csvFile, this.csvFile.name);

      // this.orderService.uploadFile(formData).subscribe(
      //   (data: any) => {
      //     if (data.resultCode === '1') {
      //       this.toastr.success(data?.resultDescription);
      //       this.uploadloading = false;
      //       this.csvFile = null;
      //       (document.querySelector('input[type="file"]') as HTMLInputElement).value = '';
      //       this.isCsvUploaded = true;
      //       this.loading = false;
      //     }

      //     if (data.resultCode === '0') {
      //       this.csvFile = null;
      //       (document.querySelector('input[type="file"]') as HTMLInputElement).value = '';
      //       this.isCsvUploaded = true;
      //       this.uploadloading = false;
      //       if (data.invalidRows && data.invalidRows.length > 0) {
      //         this.uploadloading = false;
      //         this.openErrorModal(data.invalidRows);
      //       } else {
      //         if (data.errorMessage) {
      //           this.uploadloading = false;
      //           this.toastr.error(data.errorMessage);
      //         }
      //       }
      //       this.loading = false;
      //     }
      //   },
      //   (error) => {
      //     this.uploadloading = false;
      //     this.authService.dataError(error);
      //     this.loading = false;
      //   }
      // );
    } else {
      console.log('No file selected');
    }
  }

  openErrorModal(invalidRows: any[], add_star?: any, is_merge?: any, current_order_no?: any) {
    const dialogRef = this.dialog.open(ErrormodalComponent, {
      data: {
        invalidRows: invalidRows,
        add_star: add_star,
        is_merge: is_merge,
        showFullBlock: true,
        current_order_no: current_order_no
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result == 'Remain_same') {
          return;
        }
        if (result.add_star === true) {
          const formValues = this.addOrderF.value;
          const match = result.current_order_no;
          const conflictNos = match ? match.split(',').map((v: string) => v.trim()) : [];

          if (conflictNos.length === 0) return;

          const addStarToMatched = (value: string, conflictValues: string[]): string => {
            if (!value) return '';
            return value
              .split(',')
              .map(v => {
                const trimmed = v.trim();
                return conflictValues.includes(trimmed) ? `${trimmed}*` : trimmed;
              })
              .join(',');
          };

          if (formValues.is_pickup_warehouse === true || formValues.is_pickup_warehouse === 'true') {
            const updatedOrderNo = addStarToMatched(formValues.order_no, conflictNos);
            this.addOrderF.patchValue({ order_no: updatedOrderNo });
            this.orderForm.delivery.orderNumber = updatedOrderNo;
          }

          if (formValues.is_dely_warehouse === true || formValues.is_dely_warehouse === 'true') {
            const updatedPo = addStarToMatched(formValues.po, conflictNos);
            this.addOrderF.patchValue({ po: updatedPo });
            this.orderForm.pickup.purchaseOrder = updatedPo;
          }

          if (formValues.is_dely_warehouse === false && formValues.is_pickup_warehouse === false) {
            const updatedPo = addStarToMatched(formValues.po, conflictNos);
            const updatedOrderNo = addStarToMatched(formValues.order_no, conflictNos);
            this.addOrderF.patchValue({ po: updatedPo });
            this.addOrderF.patchValue({ order_no: updatedOrderNo });
            this.orderForm.pickup.purchaseOrder = updatedPo;
            this.orderForm.delivery.orderNumber = updatedOrderNo;
          }
          this.handleSubmit();
        }

        if (result.is_merge == true) {
          const formValues = this.addOrderF.value;

          let mergeData: any = {
            rownumber: '1',
            order_id: this.id || (result.invalidRows && result.invalidRows.length > 0 && result.invalidRows[0].column_data ? result.invalidRows[0].column_data.order_id : null),
            order_no: '',
            warehouse: '',
            address: '',
            company: '',
            pickup_date: '',
            dely_date: '',
            single_add_order: true
          };

          const pickupAddressId = formValues.pickup_address;
          const delyAddressId = formValues.dely_address;
          const pickupAddressObj = this.addressData?.find((a: any) => a.id === pickupAddressId);
          const delyAddressObj = this.addressData?.find((a: any) => a.id === delyAddressId);
          const c = this.dateMomentObjFormat(this.addOrderF.value.pickup_date) + " " + this.getTime(true);
          const d = this.dateMomentObjFormat(this.addOrderF.value.dely_date) + " " + this.getTime(true);

          if (formValues.is_pickup_warehouse === true || formValues.is_pickup_warehouse === 'true') {
            mergeData.order_no = formValues.order_no;
            mergeData.address = delyAddressObj.address;
            mergeData.company = formValues.dely_company_name;
            mergeData.warehouse = 'Delivery';
            mergeData.pickup_date = this.getFormattedDate(c);
            mergeData.dely_date = this.getFormattedDate(d);
          } else if (formValues.is_dely_warehouse === true || formValues.is_dely_warehouse === 'true') {
            mergeData.order_no = formValues.po;
            mergeData.address = pickupAddressObj.address;
            mergeData.company = formValues.pickup_company_name;
            mergeData.warehouse = 'Pickup';
            mergeData.pickup_date = this.getFormattedDate(c);
            mergeData.dely_date = this.getFormattedDate(d);
          }

          const payload = {
            merge_data: [mergeData]
          };

          this.orderService.sendMergeData(payload).subscribe({
            next: (res) => {
              this.toast.show('success', res.resultDescription);
              this.initialFormState = JSON.stringify(this.orderForm);
              setTimeout(() => {
                this.router.navigate(['/admin/orders']);
              }, 300);
            },
            error: (err) => {
              console.error('API Error:', err);
            }
          });
        }
      } else if (result == null) {
        this.allow_order_merge = 'false';
        this.handleSubmit();
      } else {
        this.loading = false;
      }
    });
  }

  retryRow(index: number) {
    const rowToRetry = this.csvFile?.name;
    console.log('Retrying row:', rowToRetry);
  }

  downloadExcel(): void {
    this.clearFilterLoading = true;
    // this.orderService.activeDriverList();
    setTimeout(() => {
      this.clearFilterLoading = false;
    }, 300);
  }

  manualPopulate(event: any) {
    const isChecked = event.target.checked;
    this.isManualChecked = isChecked;
    this.isManualChecked1 = isChecked;
    this.isonClickOfPickupTriggered = false;
    this.addOrderF.get('isManualChecked')?.setValue(this.isManualChecked);
    this.addOrderF.get('isManualChecked1')?.setValue(this.isManualChecked1);

    setTimeout(() => {
      this.addOrderF.patchValue({
        dely_address: '',
        dely_company_name: '',
        dely_contact_name: '',
        dely_email: '',
        dely_phone: '',
        dely_alt_phone: '',
        pickup_email: '',
        order_no: '',
        pickup_address: '',
        pickup_company_name: '',
        pickup_contact_name: '',
        pickup_phone: '',
        pickup_alt_phone: '',
        po: '',
      });

      // Reset orderForm
      this.orderForm.pickup.company = '';
      this.orderForm.pickup.address = '';
      this.orderForm.pickup.contact = '';
      this.orderForm.pickup.email = '';
      this.orderForm.pickup.phone = '';
      this.orderForm.pickup.altPhone = '';
      this.orderForm.pickup.purchaseOrder = '';

      this.orderForm.delivery.company = '';
      this.orderForm.delivery.address = '';
      this.orderForm.delivery.contact = '';
      this.orderForm.delivery.email = '';
      this.orderForm.delivery.phone = '';
      this.orderForm.delivery.altPhone = '';
      this.orderForm.delivery.orderNumber = '';

      this.isCheckedWarehous[0].pickup = false;
      this.isCheckedWarehous[1].dely = false;
    }, 100);
  }

  manualPopulate1(event: any) {
    const isChecked = event.target.checked;
    this.isManualChecked1 = isChecked;
    this.isManualChecked = isChecked;
    this.isonClickOfDelyTriggered = false;
    this.addOrderF.get('isManualChecked')?.setValue(this.isManualChecked);
    this.addOrderF.get('isManualChecked1')?.setValue(this.isManualChecked1);

    setTimeout(() => {
      this.addOrderF.patchValue({
        dely_address: '',
        dely_company_name: '',
        dely_contact_name: '',
        dely_email: '',
        dely_phone: '',
        dely_alt_phone: '',
        pickup_email: '',
        order_no: '',
        pickup_address: '',
        pickup_company_name: '',
        pickup_contact_name: '',
        pickup_phone: '',
        pickup_alt_phone: '',
        po: '',
      });

      // Reset orderForm
      this.orderForm.pickup.company = '';
      this.orderForm.pickup.address = '';
      this.orderForm.pickup.contact = '';
      this.orderForm.pickup.email = '';
      this.orderForm.pickup.phone = '';
      this.orderForm.pickup.altPhone = '';
      this.orderForm.pickup.purchaseOrder = '';

      this.orderForm.delivery.company = '';
      this.orderForm.delivery.address = '';
      this.orderForm.delivery.contact = '';
      this.orderForm.delivery.email = '';
      this.orderForm.delivery.phone = '';
      this.orderForm.delivery.altPhone = '';
      this.orderForm.delivery.orderNumber = '';

      this.isCheckedWarehous[0].pickup = false;
      this.isCheckedWarehous[1].dely = false;
    }, 100);
  }

  navigateToDetail() {
    const parentorder = localStorage.getItem('parentorderid');
    if (parentorder != null || parentorder != 'null') {
      this.router.navigateByUrl(`/admin/orders/order-detail/${parentorder}`);
    } else {
      this.router.navigateByUrl('/admin/orders/order-detail/{{id}}');
    }
  }

  async canDeactivate(): Promise<boolean> {
    const currentState = JSON.stringify(this.orderForm);

    if (currentState === this.initialFormState) {
      localStorage.setItem('fromOrderDetail', 'true');
      return true;
    }

    const confirmed = await this.dialogService.confirm(
      'Discard Changes',
      'Are you sure you want to leave? Any unsaved changes will be lost.'
    );

    if (confirmed.confirmed) {
      localStorage.setItem('fromOrderDetail', 'true');
    }
    
    return confirmed.confirmed;
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    const currentState = JSON.stringify(this.orderForm);
    if (currentState !== this.initialFormState) {
      $event.returnValue = true;
    }
  }

  async cancel(): Promise<void> {
    const currentState = JSON.stringify(this.orderForm);

    // If no changes were made, simply close/navigate back
    if (currentState === this.initialFormState) {
      localStorage.setItem('fromOrderDetail', 'true');
      window.history.back();
      return;
    }

    const confirmed = await this.dialogService.confirm(
      'Discard Changes',
      'Are you sure you want to cancel? Any unsaved changes will be lost.'
    );

    if (confirmed.confirmed) {
      localStorage.setItem('fromOrderDetail', 'true');
      this.initialFormState = JSON.stringify(this.orderForm);
      window.history.back();
    }
  }

  captureInitialState(): void {
    this.initialFormState = JSON.stringify(this.orderForm);
  }

  resetForm(): void {
    this.orderForm = {
      pickup: {
        mode: 'auto',
        purchaseOrder: '',
        company: '',
        address: '',
        date: '',
        time: '',
        contact: '',
        email: '',
        countryCode: localStorage.getItem('countryCode') || '+1',
        phone: '',
        altPhone: '',
        notes: '',
        timeInterval: 't15',
        signatureRequired: false,
        firstDelivery: 0
      },
      delivery: {
        mode: 'auto',
        orderNumber: '',
        company: '',
        address: '',
        date: '',
        time: '',
        contact: '',
        email: '',
        countryCode: localStorage.getItem('countryCode') || '+1',
        phone: '',
        altPhone: '',
        notes: '',
        timeInterval: 't15',
        signatureRequired: false,
        firstDelivery: 0
      }
    };
    this.errors = {};
    this.pickupNotesRemaining = 200;
    this.deliveryNotesRemaining = 200;
    this.cdr.markForCheck();
  }


  goBack(): void {
    window.history.back();
  }
  searchResults() {

    var elt: any = document.getElementById('pickup_company_name-search-field');
    var elt2: any = document.getElementById('dely_company_name-search-field');
    var elt3: any = document.getElementById('pickup_company_address-search-field');
    var elt4: any = document.getElementById('dely_company_address-search-field');

    //  elt.focus();
    //  elt2.focus();
    //  elt3.focus();
    //  elt4.focus();

    let searchResults: any = document.getElementsByClassName('select2-results');
    for (let index = 0; index < searchResults.length; index++) {
      searchResults[index].style.display = 'none';
    }

  }
  onPickupTimeSet(event: any) {
    this.orderForm.pickup.time = event;
  }
  onDelyTimeSet(event: any) {
    this.orderForm.delivery.time = event;
  }
  highlightedIndex: number = -1;
  @ViewChild('deliveryDropdown') deliveryDropdown!: ElementRef;
  handleKeyDown(event: KeyboardEvent) {

    const total = this.filteredDeliveryCompanies.length;

    if (!this.showDeliveryCompanyDropdown || total === 0) return;

    // Arrow Down
    if (event.key === 'ArrowDown') {
      event.preventDefault();

      if (this.highlightedIndex < total - 1) {
        this.highlightedIndex++;
      } else {
        this.highlightedIndex = 0;
      }
      setTimeout(() => this.scrollToActiveItem());
    }

    // Arrow Up
    else if (event.key === 'ArrowUp') {
      event.preventDefault();

      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      } else {
        this.highlightedIndex = total - 1;
      }
      setTimeout(() => this.scrollToActiveItem());
    }

    // Enter
    else if (event.key === 'Enter') {
      event.preventDefault();

      // Agar sirf 1 result hai
      if (total === 1) {
        this.selectDeliveryCompany(this.filteredDeliveryCompanies[0]);
      }

      // Agar koi highlighted hai
      else if (this.highlightedIndex >= 0) {
        this.selectDeliveryCompany(
          this.filteredDeliveryCompanies[this.highlightedIndex]
        );
      }
    }
  }
  scrollToActiveItem() {
    if (!this.deliveryDropdown) return;

    const dropdown = this.deliveryDropdown.nativeElement;
    const activeItem = dropdown.querySelector('.combo-option.active');

    if (activeItem) {
      activeItem.scrollIntoView({
        block: 'nearest'
      });
    }
  }
  highlightedPickupIndex: number = -1;
  handlePickupKeyDown(event: KeyboardEvent) {

    const total = this.filteredPickupCompanies.length;

    if (!this.showPickupCompanyDropdown || total === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();

      this.highlightedPickupIndex =
        this.highlightedPickupIndex < total - 1
          ? this.highlightedPickupIndex + 1
          : 0;

      setTimeout(() => this.scrollPickupToActive());
    }

    else if (event.key === 'ArrowUp') {
      event.preventDefault();

      this.highlightedPickupIndex =
        this.highlightedPickupIndex > 0
          ? this.highlightedPickupIndex - 1
          : total - 1;

      setTimeout(() => this.scrollPickupToActive());
    }

    else if (event.key === 'Enter') {
      event.preventDefault();

      if (this.highlightedPickupIndex >= 0) {
        this.selectPickupCompany(
          this.filteredPickupCompanies[this.highlightedPickupIndex]
        );
      }
    }
  }
  @ViewChild('pickupDropdown') pickupDropdown!: ElementRef;

  scrollPickupToActive() {
    if (!this.pickupDropdown) return;

    const dropdown = this.pickupDropdown.nativeElement;
    const activeItem = dropdown.querySelector('.combo-option.active');

    if (activeItem) {
      activeItem.scrollIntoView({
        block: 'nearest'
      });
    }
  }
  highlightedPickupAddressIndex: number = -1;

  handlePickupAddressKeyDown(event: KeyboardEvent) {

    const total = this.filteredPickupAddresses.length;

    if (!this.showPickupAddressDropdown || total === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();

      this.highlightedPickupAddressIndex =
        this.highlightedPickupAddressIndex < total - 1
          ? this.highlightedPickupAddressIndex + 1
          : 0;

      setTimeout(() => this.scrollPickupAddressToActive());
    }

    else if (event.key === 'ArrowUp') {
      event.preventDefault();

      this.highlightedPickupAddressIndex =
        this.highlightedPickupAddressIndex > 0
          ? this.highlightedPickupAddressIndex - 1
          : total - 1;

      setTimeout(() => this.scrollPickupAddressToActive());
    }

    else if (event.key === 'Enter') {
      event.preventDefault();

      if (this.highlightedPickupAddressIndex >= 0) {
        this.selectPickupAddress(
          this.filteredPickupAddresses[this.highlightedPickupAddressIndex]
        );
      }
    }
  }
  @ViewChild('pickupAddressDropdown') pickupAddressDropdown!: ElementRef;

  scrollPickupAddressToActive() {
    if (!this.pickupAddressDropdown) return;

    const dropdown = this.pickupAddressDropdown.nativeElement;
    const activeItem = dropdown.querySelector('.combo-option.active');

    if (activeItem) {
      activeItem.scrollIntoView({
        block: 'nearest'
      });
    }
  }
  highlightedDeliveryAddressIndex: number = -1;
  handleDeliveryAddressKeyDown(event: KeyboardEvent) {

    const total = this.filteredDeliveryAddresses.length;

    if (!this.showDeliveryAddressDropdown || total === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();

      this.highlightedDeliveryAddressIndex =
        this.highlightedDeliveryAddressIndex < total - 1
          ? this.highlightedDeliveryAddressIndex + 1
          : 0;

      setTimeout(() => this.scrollDeliveryAddressToActive());
    }

    else if (event.key === 'ArrowUp') {
      event.preventDefault();

      this.highlightedDeliveryAddressIndex =
        this.highlightedDeliveryAddressIndex > 0
          ? this.highlightedDeliveryAddressIndex - 1
          : total - 1;

      setTimeout(() => this.scrollDeliveryAddressToActive());
    }

    else if (event.key === 'Enter') {
      event.preventDefault();

      if (this.highlightedDeliveryAddressIndex >= 0) {
        this.selectDeliveryAddress(
          this.filteredDeliveryAddresses[this.highlightedDeliveryAddressIndex]
        );
      }
    }
  }
  @ViewChild('deliveryAddressDropdown') deliveryAddressDropdown!: ElementRef;

  scrollDeliveryAddressToActive() {
    if (!this.deliveryAddressDropdown) return;

    const dropdown = this.deliveryAddressDropdown.nativeElement;
    const activeItem = dropdown.querySelector('.combo-option.active');

    if (activeItem) {
      activeItem.scrollIntoView({
        block: 'nearest'
      });
    }
  }


}